import axios, { AxiosInstance, AxiosResponse } from "axios";
import moment from "moment";

import Constantes from "./Constantes";
import URLS, { envMode } from "./UrlsVO";
import Utils from "./Utils";
import { Mutex } from "async-mutex";
import Cookies from "js-cookie";

export interface AxiosListener {
    updateLoading(loading: boolean): void;
}

export default class AxiosHttp {
    static httpInstance: AxiosInstance;
    static requestCount = 0;
    static mutex = new Mutex();
    private static observers: AxiosListener[] = [];

    static addListener(listener: AxiosListener) {
        AxiosHttp.observers.push(listener);
    }

    static removeListener(listener: AxiosListener) {
        AxiosHttp.observers.splice(AxiosHttp.observers.indexOf(listener), 1);
    }

    static async ingRequestCount() {
        await AxiosHttp.mutex.runExclusive(() => {
            AxiosHttp.requestCount++;

            if (AxiosHttp.requestCount > 0) {
                // useGlobalStore().setLoading(true);
                AxiosHttp.observers.forEach((o) => o.updateLoading(true));
            }
        });
    }

    static async decRequestCount() {
        await AxiosHttp.mutex.runExclusive(() => {
            if (AxiosHttp.requestCount > 0) AxiosHttp.requestCount--;

            if (AxiosHttp.requestCount <= 0) {
                // useGlobalStore().setLoading(false);
                AxiosHttp.observers.forEach((o) => o.updateLoading(false));
            }
        });
    }

    handleRespose(res: AxiosResponse<any, any>) {
        if (!res) {
            const err = new Error("Não houve resposta do servidor.");
            Utils.exibirErro(err.message);
            throw err;
        }
        return res.status == 200 ? res.data : null;
    }

    get http() {
        return AxiosHttp.httpInstance;
    }

    static _initialize = (() => {
        const axiosConfig = {
            baseURL: URLS.api,

            headers: {
                common: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            },
        };
        if (envMode() != "production") {
            // axiosConfig.baseURL = "http://localhost:8080/api";
            console.log(`Utilizando baseURL de ${envMode()}: ` + axiosConfig.baseURL);
        }
        this.httpInstance = axios.create(axiosConfig);

        // Para sempre enviar o Header JWT de auth e configurar parametros de data
        this.httpInstance.interceptors.request.use(
            (config) => {
                AxiosHttp.ingRequestCount();

                config.withCredentials = true;
                // @ts-ignore
                const jwt = Cookies.get("jwt");
                if (jwt && jwt != "null") {
                    config.headers["Authorization"] = "Bearer " + jwt;
                }

                if (config.params) {
                    for (const paramName of Object.keys(config.params)) {
                        if (moment.isMoment(config.params[paramName])) {
                            config.params[paramName] = config.params[paramName].format(Constantes.DATE_FORMAT);
                        } else if (config.params[paramName] instanceof Date) {
                            config.params[paramName] = moment(config.params[paramName]).format(Constantes.DATE_FORMAT);
                        }
                    }
                }
                return config;
            },
            (error) => {
                console.error("Erro ao acessar WebService: " + error);
                return Promise.reject(error);
            }
        );
        this.httpInstance.interceptors.response.use(
            (response) => {
                AxiosHttp.decRequestCount();

                return response;
            },
            (error) => {
                AxiosHttp.decRequestCount();
                if (AxiosHttp.requestCount <= 0) {
                    // useGlobalStore().setLoading(false);
                    AxiosHttp.observers.forEach((o) => o.updateLoading(false));
                }

                return Promise.reject(error);
            }
        );
    })();
}

export class GoModeException {
    public static GENERAL_ERROR = 0;
    public static ROUTINE_HAS_SCORES = 1;

    constructor(
        public timestamp?: string,
        public status?: number,
        public error?: string,
        public trace?: string,
        public message?: string,
        public path?: string,
        public errorCode?: number
    ) {}
}
